// extracted by mini-css-extract-plugin
module.exports = {"notes":"BookingEngineConfigDetailsCard_notes__3r8fE","notesText":"BookingEngineConfigDetailsCard_notesText__6SaML"};